import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const AutosarE2EGuidePage = () => <DataDrivenGuidePage slug="guide-autosar-e2e" />;

export default AutosarE2EGuidePage;
